import { createContext, useContext } from 'react';
/**
 * This provides the data that will be used by Smart Links Flexible UI to populate it's
 * underlying elements.
 */
export var FlexibleCardContext = /*#__PURE__*/createContext(undefined);
export var useFlexibleCardContext = function useFlexibleCardContext() {
  return useContext(FlexibleCardContext);
};
export var useFlexibleUiContext = function useFlexibleUiContext() {
  var _useFlexibleCardConte;
  return (_useFlexibleCardConte = useFlexibleCardContext()) === null || _useFlexibleCardConte === void 0 ? void 0 : _useFlexibleCardConte.data;
};
export var useFlexibleUiOptionContext = function useFlexibleUiOptionContext() {
  var _useFlexibleCardConte2;
  return (_useFlexibleCardConte2 = useFlexibleCardContext()) === null || _useFlexibleCardConte2 === void 0 ? void 0 : _useFlexibleCardConte2.ui;
};